<app-base-layout>
    <div class="welcome-btn-group">
        <h1>Bem vindo! Por favor selecione uma das opcoes abaixo.</h1>
        <app-rounded-button [minWidth]="350" routerLink="/init-app">
            Nova proposta
        </app-rounded-button>
        <app-rounded-button  [minWidth]="350">
            Consultar status em andamento
        </app-rounded-button>
    </div>
</app-base-layout>
